import { getCallAPIProvider } from "services/CallAPIProvider";
import { RequestManager } from "../utils/request";

const { default: BaseCCModerationProvider } = require("./BaseProvider");

class WebProvider extends BaseCCModerationProvider {
  constructor(baseUrl = "") {
    super();

    this.baseUrl = baseUrl;
    this.requestManager = new RequestManager(this.baseUrl);
  }

  get vidyoConnector() {
    return getCallAPIProvider().vidyoConnector;
  }

  async getSubscriptionToken(conferenceId, localParticipantID, scopes) {
    const url = `/subscribe`;
    const body = JSON.stringify({
      conferenceId: conferenceId,
      localParticipantScipId: localParticipantID,
      scope: scopes,
    });

    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "getSubscriptionToken",
        body
      );
      return res;
    } catch (error) {
      console.error(JSON.stringify(error));
    }
  }

  async featureDiscovery(conferenceId, remoteParticipantIDs) {
    const url = `/feature/discover`;
    const body = JSON.stringify({
      conferenceId: conferenceId,
      remoteParticipantScipIdList: remoteParticipantIDs,
    });

    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "featureDiscovery",
        body
      );
      return res;
    } catch (error) {
      console.error(JSON.stringify(error));
    }
  }

  async sendCommand(
    conferenceId,
    remoteParticipantIDs,
    featureId,
    featureKey,
    valueObject
  ) {
    const url = `/feature/command`;
    const body = JSON.stringify({
      conferenceId: conferenceId,
      remoteParticipantScipId: remoteParticipantIDs,
      featureId: featureId,
      featureKey: featureKey,
      setValue: valueObject,
    });

    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "sendCommand",
        body
      );
      return res;
    } catch (error) {
      console.error(JSON.stringify(error));
    }
  }

  async subscribeToTopic(token, messageCallback, statusCallback) {
    try {
      return this.vidyoConnector.SubscribeToTopic({
        topicSubscriptionToken: token,
        messageCallback: messageCallback,
        statusCallback: statusCallback,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async unsubscribeFromTopic(token) {
    try {
      return this.vidyoConnector.UnsubscribeFromTopic({
        topicSubscriptionToken: token,
      });
    } catch (error) {
      console.error(error);
    }
  }
}

export default WebProvider;
